import { JsonObject, JsonProperty } from 'json2typescript';

import { City } from './city';
import { County } from './county';
import { Province } from './province';

/**
 * å»é¢å°å
 */
@JsonObject
export class TenantAddress {
  /**
   * æå±å¸çº§è¡æ¿åº
   */
  @JsonProperty('city', City)
  city: City = undefined;

  /**
   * æå±å¿çº§è¡æ¿åº
   */
  @JsonProperty('county', County)
  county: County = undefined;

  /**
   * å·ä½å°å
   */
  @JsonProperty('detail', String)
  detail: string = undefined;

  /**
   * æå±ççº§è¡æ¿åº
   */
  @JsonProperty('province', Province)
  province: Province = undefined;
}
